<template>
  <div>
    <PageHeader :items="items" />
    <validation-observer ref="simpleRules">
      <div class="card">
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("firstName")
                }}</label>
                <input
                  id="firstName"
                  v-model="form.firstName"
                  name="title"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("lastName")
                }}</label>
                <input
                  id="lastName"
                  v-model="form.lastName"
                  name="title"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label"
                  ><span style="color: red">*</span>&nbsp;{{ $t("email") }}
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required"
                >
                  <input
                    id="email"
                    v-model="form.email"
                    name="title"
                    class="form-control"
                    type="text"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("city")
                }}</label>
                <input
                  id="title"
                  v-model="form.city"
                  name="title"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("street")
                }}</label>

                <input
                  id="street"
                  v-model="form.street"
                  name="street"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("streetNumber")
                }}</label>
                <input
                  id="streetNumber"
                  v-model="form.streetNumber"
                  name="streetNumber"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-3">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("zip")
                }}</label>
                <input
                  id="zip"
                  v-model="form.zip"
                  name="zip"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("mobile")
                }}</label>
                <input
                  id="mobile"
                  v-model="form.mobile"
                  name="mobile"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("phone")
                }}</label>
                <input
                  id="phoneNo"
                  v-model="form.phoneNo"
                  name="phoneNo"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="input-label form-label"
                  >{{ $t("contactLanguage") }}
                </label>
                <select
                  class="form-control"
                  v-model="form.contactLanguage"
                >
                  <option
                    v-for="language in languages"
                    :value="language.code"
                    :key="language.code"
                  >
                    {{ language.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("roles")
                }}</label>
                <multiselect
                  v-model="form.roles"
                  label="title"
                  :multiple="true"
                  track-by="id"
                  :options="roles"
                  selectLabel=""
                  deselectLabel=""
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label" for="cars"><span style="color: red">*</span>&nbsp;{{
                  $t("company")
                }}</label>
                 <validation-provider
                  #default="{ errors }"
                  name="Company"
                  rules="required"
                >
                <MultiSelectInput
                  v-model="form.company_id"
                  :options="customers"
                  :query="{ isMultiSelect: true }"
                  label="companyName"
                  trackBy="id"
                  :key="form.company_id"
                  moduleName="customers"
                  :multiple="false"
                  ><template #option="{ props }">
                    <div>
                      <p>
                        {{ props.option.companyNumber }} -
                        {{ props.option.companyName }}
                      </p>
                    </div>
                    </template>
                  </MultiSelectInput>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("types")
                }}</label>
                <multiselect
                  v-model="form.types"
                  :multiple="true"
                  :options="types"
                  selectLabel=""
                  deselectLabel=""
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="d-flex align-items-center gap-1">
                <div class="form-group w-100">
                  <label class="input-label form-label"
                    >{{ $t("password") }}
                  </label>
                  <b-input-group class="input-group-merge">
                    <b-form-input
                      id="new-password"
                      v-model="form.password"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      autocomplete="new-password"
                      name="new-password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                </div>

                <feather-icon
                  @click="generatePassword"
                  class="cursor-pointer mt-2"
                  icon="RefreshCwIcon"
                  size="16"
                />
              </div>
              <ul
                v-if="form.password"
                class="list-unstyled text-muted medium mt-1"
              >
                <li :class="{ 'text-success': hasNumber }">
                  ✔ At least 1 numeric
                </li>
                <li :class="{ 'text-success': hasUppercase }">
                  ✔ At least one capital letter
                </li>
                <li :class="{ 'text-success': hasSpecialChar }">
                  ✔ At least one special character
                </li>
                <li :class="{ 'text-success': hasValidLength }">
                  ✔ 8 characters
                </li>
              </ul>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("confirmPassword")
                }}</label>

                <b-input-group class="input-group-merge">
                  <b-form-input
                    id="new-password"
                    v-model="form.confirmPassword"
                    class="form-control-merge"
                    :type="passwordFieldType"
                    autocomplete="new-password"
                    name="new-password"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <div v-if="!passwordsMatch" style="color: red">
                  {{ $t("passwordAndConfirmPasswordShouldBeMatched") }}
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mt-1">
                <label class="input-label form-label" for="active">{{
                  $t("active")
                }}</label>

                <input
                  id="active"
                  class="form-check-input-custom ml-2"
                  v-model="form.status"
                  type="checkbox"
                />
              </div>
            </div>
             <div v-if="lastLogin && lastLogin.date" class="col-md-4">
               <div class="form-group mt-1">
                 <label class="input-label form-label" for="active">{{
                   $t("lastLogin")
                 }}</label>

                 <p>{{ formatLastLoginDate(lastLogin.date) }}</p>
               </div>
             </div>
          </div>
        </div>
      </div>
    </validation-observer>
    
    <!-- Last Login Table -->
    <!-- <div v-if="lastLogin" class="card mt-3">
      <div class="card-body">
        <h5 class="card-title text-primary">{{ $t("lastLogin") }}</h5>
        <div class="table-responsive">
          <table class="table table-bordered table-hover">
            <tbody>
              <tr>
                <td class="font-weight-bold text-dark">{{ $t("date") }}</td>
                <td class="text-dark">{{ formatLastLoginDate(lastLogin.date) }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold text-dark">{{ $t("timezone") }}</td>
                <td class="text-dark">{{ lastLogin.timezone }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold text-dark">{{ $t("timezoneType") }}</td>
                <td class="text-dark">{{ lastLogin.timezone_type }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div> -->
    
    <div class="d-flex justify-content-end">
      <div class="mt-2 max-w-3xl d-flex align-items-center gap-2">
        <b-button @click="sendMail()" class="cursor-pointer">
          <span class="mr-25 align-middle">{{
            $t("sendNewRegistrationMail")
          }}</span>
          <feather-icon icon="PlusIcon" size="12" />
        </b-button>

        <b-button
          @click="updateUser()"
          class="cursor-pointer"
          :disabled="isFormInvalid"
        >
          <span class="mr-25 align-middle">{{ $t("updateUser") }}</span>
          <feather-icon icon="PlusIcon" size="12" />
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import PageHeader from "@/components/PageHeader.vue";
import Multiselect from "vue-multiselect";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import { mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import formDirtyMixin from "@/mixins/formDirtyMixin";

export default {
  components: {
    TextInput,
    PageHeader,
    Multiselect,
    MultiSelectInput,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility, formDirtyMixin],
  watch: {
    "form.password"(...val) {
      this.passwordsMatch = true;
    },
    "form.confirmPassword"(...val) {
      this.passwordsMatch = true;
    },
    "form.company_id": {
      handler(newCompany) {
        if (newCompany && newCompany.preferredContactLanguage && (!this.form.contactLanguage || this.form.contactLanguage === "")) {
          this.form.contactLanguage = this.mapLanguageToCode(newCompany.preferredContactLanguage);
        }
      },
      deep: true,
    },
    form: {
      handler(newVal) {
        this.isFormDirty = JSON.stringify(newVal) !== this.originalForm;
      },
      deep: true,
    },
  },
  data() {
    return {
      originalForm: null,
      submitted: false,
      form: {
        firstName: "",
        lastName: "",
        email: "",
        city: "",
        street: "",
        streetNumber: "",
        zip: "",
        mobile: "",
        phoneNo: "",
        roles: [],
        types: [],
        password: "",
        confirmPassword: "",
        company_id: "",
        status: true,
        contactLanguage: "",
      },
      lastLogin: null,

      types: ["customer_employee", "employee", "partner"],
      languages: [
        { code: "en", label: "English" },
        { code: "de", label: "German" },
        { code: "fr", label: "French" },
        { code: "es", label: "Spanish" },
        { code: "tr", label: "Turkish" },
      ],
      passwordsMatch: true,
    };
  },
  computed: {
    ...mapGetters("roles", ["roles"]),
    ...mapGetters("customers", ["customers"]),
    hasNumber() {
      return /\d/.test(this.form.password);
    },
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    hasUppercase() {
      return /[A-Z]/.test(this.form.password);
    },
    hasSpecialChar() {
      return /[^a-zA-Z0-9]/.test(this.form.password);
    },
    hasValidLength() {
      return this.form.password.length >= 8;
    },
    isPasswordValid() {
      return (
        this.hasNumber &&
        this.hasUppercase &&
        this.hasSpecialChar &&
        this.hasValidLength
      );
    },
    items() {
      return [
        {
          text: this.$t("dentalTwin"),
          to: "/home",
        },
        {
          text: this.$t("users"),
          to: "/users",
        },
        {
          text: this.$t("edit"),
          active: true,
        },
      ];
    },
    isFormInvalid() {
      return !this.form.email || !this.form.company_id;
    },
  },
  async mounted() {
    try {
      this.$store.commit("showLoader", true);
      await this.$store.dispatch("roles/list", {
        limit_start: 0,
        limit_count: 100,
      });
      await this.$store.dispatch("customers/list", { isMultiSelect: true });
      this.refresh();
    } catch (e) {
      console.error("api error ___", e);
    } finally {
      this.$store.commit("showLoader", false);
    }
  },
  methods: {
    mapLanguageToCode(languageName) {
      const languageMap = {
        'English': 'en',
        'French': 'fr',
        'German': 'de',
        'Spanish': 'es',
        'Turkish': 'tr'
      };
      return languageMap[languageName] || '';
    },
    formatLastLoginDate(dateString) {
      if (!dateString || dateString === null || dateString === undefined) return '';
      try {
        // Parse the UTC date string and convert to local time
        const date = new Date(dateString + ' UTC');
        return date.toLocaleString();
      } catch (error) {
        return dateString;
      }
    },
    generatePassword() {
      const numbers = "0123456789";
      const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const lowercase = "abcdefghijklmnopqrstuvwxyz";
      const specialChars = "!@#$%^&*()_+-=[]{}|;:,.<>?";
      const allChars = numbers + uppercase + lowercase + specialChars;

      // Ensure each requirement is met at least once
      let password = "";
      password += numbers[Math.floor(Math.random() * numbers.length)];
      password += uppercase[Math.floor(Math.random() * uppercase.length)];
      password += specialChars[Math.floor(Math.random() * specialChars.length)];

      // Fill remaining characters
      while (password.length < 8) {
        password += allChars[Math.floor(Math.random() * allChars.length)];
      }

      // Shuffle password characters for randomness
      password = password
        .split("")
        .sort(() => 0.5 - Math.random())
        .join("");

      // Set password to form model (assuming form.password is your v-model)
      this.form.password = password;
      this.form.confirmPassword = password;
    },
    async refresh() {
      try {
        this.$store.commit("showLoader", true);
        this.$store
          .dispatch("users/show", {
            id: this.$route.params.id,
          })
          .then(async (res) => {
            if (res.message_type === "error") {
              return;
            } else {
              var response = res?.data;
              this.form.street = response.street;
              this.form.streetNumber = response.street_number;
              this.form.zip = response.zip;
              this.form.firstName = response.first_name;
              this.form.lastName = response.last_name;
              this.form.company_id = response.company_id;
              this.form.email = response.email;
              this.form.city = response.city;
              this.form.phoneNo = response.phone;
              this.form.types = response.types;
              this.form.contactLanguage = response.contact_language || "";
              this.form.status = response.status !== undefined ? response.status === 1 : true;
              this.lastLogin = response.last_login || null;
              this.form.types = Object.keys(this.form.types).filter(
                (type) => this.form.types[type] == 1
              );
              this.form.roles = response.roles
                .map((roleId) => {
                  return {
                    ...(this.roles.find((role) => role.id == roleId) ?? {}),
                  };
                })
                .filter((role) => role.id);

              let company =
                this.customers?.find(
                  (company) => company.id == this.form.company_id
                ) ?? "";
              // if the company does not exist in the companies listing then use the show API to fetch the company separately
              if (!company && this.form.company_id) {
                let res = await this.$store.dispatch(
                  "customers/show",
                  this.form.company_id
                );
                company = res?.data?.modelData ?? "";
              }
              this.form.company_id = company;
              this.originalForm = JSON.stringify(this.form);
            }
          });
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
    async sendMail() {
      try {
        const payload = {
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          email: this.form.email,
        };
        this.$store.commit("showLoader", true);
        await this.$store.dispatch("users/sendMail", payload).finally(() => {
          this.$store.commit("showLoader", false);
        });
      } catch (e) {
        this.$store.commit("showLoader", false);
        console.error("api error", e);
      }
    },
    async updateUser() {
      try {
        this.submitted = true;
        this.passwordsMatch = true;
        const payload = {
          id: this.$route.params.id,
          first_name: this.form.firstName,
          last_name: this.form.lastName,
          mail: this.form.email,
          phone: this.form.phoneNo,
          city: this.form.city,
          street: this.form.street,
          types: this.form.types,
          street_number: this.form.streetNumber,
          zip: this.form.zip,
          company_id: this.form.company_id?.id ?? "",
          set_company_id: this.form.company_id?.id ?? "",
          status: this.form.status ? 1 : 0,
          contact_language: this.form.contactLanguage,
          roles:
            this.form.roles && this.form.roles.length
              ? this.form.roles.map((role) => role.id)
              : [],
        };

        if (this.form.password) {
          payload.password = this.form.password;
          if (this.form.password !== this.form.confirmPassword) {
            this.passwordsMatch = false;
            return false;
          }
          if (!this.isPasswordValid) {
            return false;
          }
        }
        this.$refs.simpleRules.validate().then(async (success) => {
          if (success) {
            this.$store.commit("showLoader", true);
            this.isLoading = true;
            const response = await this.$store.dispatch(
              "users/update",
              payload
            );
            this.isLoading = false;
            if (
              response.hasOwnProperty("message_type") &&
              response.message_type == "error"
            ) {
            } else {
              this.isFormDirty = false;
              this.originalForm = JSON.stringify(this.form);
              await this.$router.push({ path: "/users" });
            }
          }
        });
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
  },
};
</script>

<style>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
